  import axios from 'axios';
  import { NodeUrl, Url } from './Path';

  export const connect = axios.create({
    baseURL: Url,
    headers: {
      'Mobile-App-api-token': 'So5gUf6ZbUHQU9SsP2j1Usx0PUCKA9gJJM2Kkgz7Fic0toLYTK14F2LKh4VXMBHR0sMKM0Y4WI7v71B8He5YdvM1YxsfKBJr6SXcJVUPrUC2owuerc61s3t29sETpzHKYvafTrk9JPs0x185ApQkr-pSLJsa3w60HlV7DF5gRLujCt6oCFET08fFu',
    }
  });


  export const Node = axios.create({
    baseURL: NodeUrl,
    headers: {
      'Admin_Pannel_Token': 'ujhj45ON8BKl!udLGPu!szcWtY!e9MTm4jpXSqD7wNM1HITpnbJhhp=aElxgkShcdaBhvgqLeOMjz9G?qliY6FK/AcJN0iTB3fIl5g55bllJHdrF-Yh-O4W-eEjKaPk/DBGqHU6XDhbG5m68RtVxZGH?B6n1F5u=F84npBeJIMS/SzrT7=dXuAj=8aqDyvRpIh=nswd!XPTMobzhw2jKxocrOYJkzo0osZFSMxK1hMqRbqGJIKR=bgRfS!cea11f',
    }
  });
